<template>
    <div class="contact-us" :style="bcStyle">
        <span v-if="block.inner.title"
            class="title"
            v-html="$getConfigText(block.inner.title)">
        </span>
        <span class="content"
            v-html="$getConfigText(block.inner.content)">
        </span>
    </div>
</template>

<style scoped>
.contact-us{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 60px 0;
}
.title{
    width: 1012px;
    font-size: 34px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 60px;
}
.content{
    width: 1188px;
    line-height: 30px;
    text-align: center;
    color: #666666;
}
</style>

<script>
export default {
    props: {
        block: Object
    },
    computed: {
        bcStyle(){
            return `background:${this.block.backColor};`
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/templates/blocks/contact-us.vue